import "./AdManagerAdvertisingZonesFilter.scss";
import FilterDateInput from "@/components/Common/FilterDateInput/FilterDateInput.vue";
import { canParseJson } from "@/helpers/commonHelper";

export default {
  name: "AdManagerAdvertisingZonesFilter",
  props: ["filter", "targetOptions", "placementOptions", "formats"],
  components: {
    FilterDateInput
  },
  data: () => ({
    dialog: false,
    activeOptions: [
      { label: "Alle", value: -1 },
      { label: "Nur Aktive", value: 1 },
      { label: "Nur Inaktive", value: 0 }
    ]
  }),
  mounted() {
    this.getContentFromLocalStorage();
  },
  methods: {
    getContentFromLocalStorage() {
      this.getLocalStorageItems();
      this.updateFilter();
    },
    getLocalStorageItems() {
      const targets = localStorage.getItem("adManagerAdvertisingZonesTargets");
      this.filter.targets = canParseJson(targets) ? JSON.parse(targets) : [];

      const placements = localStorage.getItem(
        "adManagerAdvertisingZonesPlacements"
      );
      this.filter.placements = canParseJson(placements)
        ? JSON.parse(placements)
        : [];

      const formats = localStorage.getItem("adManagerAdvertisingZonesFormats");
      this.filter.formats = canParseJson(formats) ? JSON.parse(formats) : [];

      this.filter.deleted = Number(
        localStorage.getItem("adManagerAdvertisingZonesDeleted")
      );

      const active =
        localStorage.getItem("adManagerAdvertisingZonesActive") ?? -1;
      this.filter.active = Number(active);
    },

    setLocalStorageItems() {
      localStorage.setItem(
        "adManagerAdvertisingZonesTargets",
        JSON.stringify(this.filter.targets)
      );
      localStorage.setItem(
        "adManagerAdvertisingZonesPlacements",
        JSON.stringify(this.filter.placements)
      );
      localStorage.setItem(
        "adManagerAdvertisingZonesFormats",
        JSON.stringify(this.filter.formats)
      );
      localStorage.setItem(
        "adManagerAdvertisingZonesDeleted",
        this.filter.deleted
      );
      localStorage.setItem(
        "adManagerAdvertisingZonesActive",
        this.filter.active
      );
    },
    setDeleted() {
      this.filter.deleted = Number(this.filter.deleted);
      this.updateFilter();
    },
    updateFilter() {
      this.setLocalStorageItems();
      this.$emit("applyFilter");
    },
    async resetFilter() {
      this.filter.targets = [];
      this.filter.placements = [];
      this.filter.formats = [];
      this.filter.active = -1;
      delete this.filter.deleted;
      this.updateFilter();
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    cPlacementOptions() {
      const placementOptionsUnique = Object.values(this.placementOptions)
        .flat()
        .filter(
          (option, index, self) =>
            index === self.findIndex(obj => obj.value === option.value)
        );
      return [
        { label: "Keine Platzierung", value: "" },
        ...placementOptionsUnique
      ];
    }
  }
};
